import * as React from 'react';
import styled from 'styled-components';

import { CardImage } from '../../../CardImage';
import { CardLinkWrapper } from '../../../CardWrapper';
import { ConfirmBox } from '../../../../ui/popup/ConfirmBox';
import { Button } from '../../../../ui/button/Button';

import { DEL_IMAGE } from '../../../../../../client/__graphql__/mutations/upload/delImage';
import { getAdminClient } from '../../AdminApolloClient';
import { useMutation } from '@apollo/client';
import { IsValidUrl } from '../../../../../utils/helpers/url';

const client = getAdminClient();

export const CardStyle = styled.div`
  color: ${({ theme }) => theme.colors.black};
  position: relative;
  bottom: 20px;
  background-color: ${({ theme }) => theme.colors.white};
  width: 80%;
  margin-top: -10px;
  /*   height: 230px; */
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 38px 30px;
  box-shadow: 0 0 20px rgb(0, 0, 0, 0.2);
  height: calc(100% - 250px);
  h4 {
    font-size: 20px;
  }

  @media all and (min-width: 751px) and (max-width: 853px) {
    min-height: 150px;
  }
  @media all and (min-width: 1151px) {
    min-height: 150px;
  }

  @media all and (min-width: 375px) {
    /*  height: 250px; */
    h4 {
      margin-top: -10px;
    }
    p {
      font-size: 15px;
    }
  }
`;

const BtnWrapper = styled.div`
  z-index: 3;

  button {
    margin:auto;

    :not(:last-child) {
      margin-bottom: 15px;
    }
  }
`;

export const ImageCard: React.FC<{ imgData: any, onCardClick?: any, onRefresh?: any }> = ({
  imgData,
  onCardClick,
  onRefresh
}) => {
  const [image, setImage] = React.useState(imgData);
  const [showConfirm, setShowConfirm] = React.useState(false);

  const [del, { error, loading, data }] = useMutation(DEL_IMAGE, {
    client,
    onCompleted: (data: any) => {
      if (data?.delImage && onRefresh) {
        onRefresh();
      }
    }
  });

  const clickDelete = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    setShowConfirm(true);
  };
  const close = () => {
    setShowConfirm(false);
  };

  const handleDelete = (e: any) => {
    //e.preventDefault();
    del({
      variables: {
        input: { id: image?.id }
      }
    }
    );
  };

  const onClick = (e: any) => {
    //e.preventDefault();
    if (onCardClick && image && image?.key) {
      onCardClick(image?.key);
    }
  }

  return (<Container onClick={onClick} >
    <CardImage image={image?.url} description={'bilde'} />
    <CardStyle>
      {image?.title ? <h4>{image?.title}</h4> : null}
      {image?.description ? <DivItem dangerouslySetInnerHTML={{ __html: image?.description }} /> : null}
      <BtnWrapper>
        {image?.link_to && image?.link_to?.trim()?.length > 0 ?
          <LinkButton title={image?.link_to} onClick={(e: any) => {
            if (IsValidUrl(image?.link_to)) {
              e.stopPropagation();
              e.preventDefault();
              window.open(image?.link_to, '_blank');
            }
          }}>
            <div className='title'>Åpne lenke:</div>
            <div className='text'>{image?.link_to}</div>
          </LinkButton> : null}
        <Button type="primary" colorTheme="gold" onClick={clickDelete}>
          Slett
        </Button>
      </BtnWrapper>
    </CardStyle>
    {showConfirm && <ConfirmBox className={'pop'} close={close} handleDelete={handleDelete} />}
  </Container >);
}


const LinkButton = styled.div`
  background-color: #242525;
  color: #E8C893;
  border-bottom: solid 2px #242525;
  cursor: pointer;
  padding:15px;
  margin-bottom:10px;

  .title {
    padding-bottom: 5px;
  }

  .text {
    text-align: left;
  }
`;

const Container = styled.div`
  position: relative;
  background-color: #260b11;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  text-align: center;

  .pop {
    width: 95%;
  }
`;

const DivItem = styled.div`
  padding-bottom: 15px;
`;

const DivLink = styled.div`
  padding: 2px 0px;
  z-index: 3;
  
  span {
    padding-right: 3px;
  }
`;